import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import defaultSettings from '@tools/defaultSettings';

const init = async (lang?: string) => {
    const currentLang = lang || defaultSettings.lang;
    const resources =  {
        [currentLang] : {
            translation : await import(`../locales/${currentLang}.json`)
        }
    }

    const environment = process.env.REACT_APP_NODE_ENV

    return i18n
        .use(LanguageDetector)
        .use(initReactI18next)
        .init({
            debug: environment === "development",
            ...lang && {lng: lang},
            fallbackLng: defaultSettings.lang,
            resources: resources
        });
}

export default init;
